var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 0.5,
    y: 0.5,
    stroke: "#8C8E92",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8E92",
    fillRule: "evenodd",
    d: "M6.2 13.022a.1.1 0 0 0 .1.1h3.4a.1.1 0 0 0 .1-.1v-.459a.1.1 0 0 0-.1-.1c-.378 0-.555-.071-.724-.198-.163-.123-.25-.308-.25-.574V6.489a.1.1 0 0 0-.121-.098L6.4 6.865a.1.1 0 0 0-.079.098v.413a.1.1 0 0 0 .1.1c.288 0 .489.092.621.264.136.176.213.452.213.845v3.045c0 .292-.082.494-.23.625-.15.133-.387.208-.726.208a.1.1 0 0 0-.1.1v.459Zm.765-9.172c0 .323.07.585.227.766.16.183.394.267.684.267.312 0 .565-.082.738-.264.172-.181.25-.444.25-.769 0-.305-.073-.552-.235-.723-.162-.172-.4-.249-.692-.249-.306 0-.554.077-.725.247-.17.171-.247.419-.247.725Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMark);
export default __webpack_public_path__ + "static/media/infoMark.ddc74407721650a269dca10b591d5ba1.svg";
export { ForwardRef as ReactComponent };